import { http } from './client';
import { API_ROUTES } from './routes';
import type {
  IMeInfo,
  ILoginPayload,
  ILoginResponse,
  IVerifyEmailPayload,
  IVerifyEmailResponse,
  IUAEPassLoginResponse,
} from '@/types/auth';

export const authApi = {
  // withCredentials required on cookie endpoints so the browser stores/sends
  // the httpOnly refresh_token cookie on cross-origin requests
  login: (payload: ILoginPayload): Promise<ILoginResponse> =>
    http
      .post(API_ROUTES.authentication.login, payload, { withCredentials: true })
      .then((r) => r.data),

  getMe: (): Promise<IMeInfo> =>
    http.get(API_ROUTES.authentication.me).then((r) => r.data),

  logout: (): Promise<void> =>
    http.post(API_ROUTES.authentication.logout, {}, { withCredentials: true }).then((r) => r.data),

  refresh: (): Promise<ILoginResponse> =>
    http
      .post(API_ROUTES.authentication.refresh, {}, { withCredentials: true })
      .then((r) => r.data),

  sendEmailVerificationLink: (): Promise<void> =>
    http.post(API_ROUTES.authentication.sendEmailVerificationLink).then((r) => r.data),

  verifyEmail: (payload: IVerifyEmailPayload): Promise<IVerifyEmailResponse> =>
    http.post(API_ROUTES.authentication.verifyEmail, payload).then((r) => r.data),

  uaePassLogin: (): Promise<IUAEPassLoginResponse> =>
    http.get(API_ROUTES.authentication.uaePassLogin).then((r) => r.data),

  uaePassCallback: (code: string, state: string): Promise<ILoginResponse> =>
    http
      .post(API_ROUTES.authentication.uaePassCallback, { code, state }, { withCredentials: true })
      .then((r) => r.data),

  uaePassLogoutUrl: (payload: { idTokenHint?: string; postLogoutRedirectUri?: string }): Promise<{ logoutUrl: string }> =>
    http.post(API_ROUTES.authentication.uaePassLogoutUrl, payload).then((r) => r.data),
};
